import { Bar, Line } from "react-chartjs-2"

import { chartColors, commonChartOptions, lineChartOptions } from "./chartConfig"
import { ChartCard, Legend, Section, type SelectOption, SelectPill } from "./components"
import { dashboardDateRangeOptions, type EnterpriseChartData } from "./dashboardData"

import styles from "./index.module.scss"

type Props = {
  contractorOptions: SelectOption[]
  isContractorsLoading: boolean
  alertChartOption: string
  contractorId: string
  alertsOverTimeChartData: EnterpriseChartData<"line">
  alertStatusChartData: EnterpriseChartData<"bar">
  onAlertChartOptionChange: (option: string) => void
  onContractorChange: (option: string) => void
}

export const AlertsWidget = ({
  contractorOptions,
  isContractorsLoading,
  alertChartOption,
  contractorId,
  alertsOverTimeChartData,
  alertStatusChartData,
  onAlertChartOptionChange,
  onContractorChange,
}: Props) => (
  <Section
    title="Alerts"
    controls={
      <>
        <SelectPill options={dashboardDateRangeOptions} value={alertChartOption} onChange={onAlertChartOptionChange} />
        <SelectPill
          options={contractorOptions}
          value={contractorId}
          disabled={isContractorsLoading}
          onChange={onContractorChange}
        />
      </>
    }
  >
    <ChartCard title="Alerts Over Time">
      <div className={styles.largeChart}>
        <Line data={alertsOverTimeChartData} options={lineChartOptions} />
      </div>
      <Legend
        variant="line"
        items={[
          { label: "System Efficiency", color: chartColors.systemEfficiency },
          { label: "Air Quality", color: chartColors.airQuality },
          { label: "Fan Malfunction", color: chartColors.fan },
          { label: "Ambient Sensor Malfunction", color: chartColors.ambientSensor },
          { label: "Humidity Sensor Malfunction", color: chartColors.humiditySensor },
          { label: "Temperature Sensor Malfunction", color: chartColors.temperatureSensor },
        ]}
      />
    </ChartCard>
    <ChartCard title="Alerts Statuses">
      <div className={styles.largeChart}>
        <Bar data={alertStatusChartData} options={commonChartOptions} />
      </div>
      <Legend
        items={[
          { label: "Active", color: chartColors.active },
          { label: "Frozen", color: chartColors.frozen },
          { label: "Acknowledged", color: chartColors.acknowledged },
        ]}
      />
    </ChartCard>
  </Section>
)
